module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoggedIn) ? _c('span', _vm._l((_vm.tabs), function(tab, key) {
    return _c('a', {
      staticClass: "navbar-brand",
      class: {
        "active": key == _vm.$route.params.page
      },
      attrs: {
        "href": "#/" + _vm.namespace + "/" + key
      }
    }, [_vm._v(_vm._s(_vm.$t(key))), _c('div', {
      staticClass: "sub-menus",
      class: {
        "none": !tab.subtabs
      }
    }, [_c('div', {
      staticClass: "container-fluid"
    }, [_c('ul', {
      staticClass: "navbar-collapse"
    }, [_c('li', [_vm._l((tab.subtabs), function(subTab, subKey) {
      return (subKey != "label") ? _c('a', {
        class: {
          "active": _vm.isActive(key, subTab, subKey)
        },
        attrs: {
          "href": "#/" + _vm.sectionNamespace(key, subTab, subKey) + "/" + key + "/" + _vm.section(key, subTab, subKey) + "/"
        }
      }, [_vm._v(_vm._s(_vm.subNavLabel(subKey)))]) : _vm._e()
    }), (!tab.subtabs) ? _c('a') : _vm._e()], 2)])])])])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7048e92f","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/site-map/index.vue
// module id = HsUf
// module chunks = 13 14